import { FileType } from '@Components/FileUploadDropzone/FileTypes';
import { IFileSelectResult, getFileTypeFromFile } from './Interfaces';

export function areFilesValid(files: Array<File>): IFileSelectResult {
    if (files.length > 1) {
        const output = {
            isValid: true,
            message: `${files.length} images selected.`,
            fileType: FileType.JPG,
        };
        files.forEach((f) => {
            if (f.type !== 'image/jpeg') {
                output.isValid = false;
                output.message =
                    'You may only upload multiple .jpg or .jpeg images.';
            }
        });

        return output;
    } else {
        return {
            isValid: true,
            message: `${files[0].name}`,
            fileType: getFileTypeFromFile(files[0]),
        };
    }
}
